// What st8n's ui.jsx and theme.js gave the copied tickets components. Deleg8 loads the st8n tokens on :root itself.
import { createContext } from 'react'
export const DeskRoot = createContext(false)
export function useTokens() {}
